import {useEffect, useState} from 'react';

import {SupportedRegions} from '../types/lang';


const getLocalStorageArea = () => {
  const regions = Object.values(SupportedRegions) as string[];

  if (typeof localStorage !== 'undefined') {
    const area = localStorage.getItem('area') ?? '';
    return regions.includes(area) ? area as SupportedRegions : null;
  }

  return null;
};


const useSelectedArea = () => {
  const regions = Object.values(SupportedRegions) as string[];
  const [selectedArea, setSelectedArea] = useState<SupportedRegions | null>(getLocalStorageArea());

  useEffect(() => {
    if (typeof localStorage !== 'undefined') {
      if (selectedArea && regions.includes(selectedArea)) {
        localStorage.setItem('area', selectedArea);
      }
    }
  }, [selectedArea]);

  return [selectedArea, setSelectedArea] as const;
};


export default useSelectedArea;
